/* Side Menu */

function initSideMenu() {
  const sideMenu = document.querySelector(".side-menu-wrap")

  document.querySelector(".burger").addEventListener("click", e => {
    sideMenu.classList.add("active")
  })
  
  document.querySelector(".side-menu .close").addEventListener("click", e => {
    sideMenu.classList.remove("active")
  })

  document.getElementById("menu-overlay").addEventListener("click", e => {
    sideMenu.classList.remove("active")
  })
}

export { initSideMenu }